export default __webpack_public_path__ + "static/media/lineG2ptPariCut.0442aae4.png";